import moment from 'moment';
import DatePicker from 'react-datepicker';
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';

function ReportsDatesInputModalForm({
  setSpinner,
  close,
  createReport,
  aggregators,
  getAggregators,
}) {
  const [aggregatorId, setAggregatorId] = useState('');
  const [dateFrom, setDateFrom] = useState(moment().subtract(1, 'months').format('YYYY-MM-DD'));
  const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));

  useEffect(() => {
    (async () => {
      setSpinner(true);
      await getAggregators();
      setSpinner(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreate = () =>
    createReport({
      aggregatorId: aggregatorId ? Number(aggregatorId) : null,
      from: moment(dateFrom).format('YYYY-MM-DD'),
      to: moment(dateTo).format('YYYY-MM-DD'),
    });

  return (
    <>
      <div>
        <Row className="align-items-center">
          <Col md={4} className="bo-same-line">
            <Form.Label>Aggregator:</Form.Label>
          </Col>
          <Col md={8} className="bo-same-line">
            <Form.Select
              className="bo-filter bo-w-250"
              value={aggregatorId}
              onChange={e => setAggregatorId(e.target.value)}
            >
              <option value="">All Standard Aggregators</option>
              {aggregators.map(agg => (
                <option key={agg.id} value={agg.id}>
                  {agg.name}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
        <Row className="mt-2 mb-2 align-items-center">
          <Col md={4} className="bo-same-line">
            <Form.Label>From:</Form.Label>
          </Col>
          <Col md={8} className="bo-same-line">
            <DatePicker
              className="bo-input bo-date-picker bo-w-250"
              onChange={e => setDateFrom(e)}
              selected={new Date(dateFrom)}
              dateFormat="yyyy-MM-dd"
              customInput={<Form.Control />}
            />
          </Col>
        </Row>
        <Row className="mt-2 mb-2 align-items-center">
          <Col md={4} className="bo-same-line">
            <Form.Label>To:</Form.Label>
          </Col>
          <Col md={8} className="bo-same-line">
            <DatePicker
              className="bo-input bo-date-picker bo-w-250"
              onChange={e => setDateTo(e)}
              selected={new Date(dateTo)}
              dateFormat="yyyy-MM-dd"
              customInput={<Form.Control />}
            />
          </Col>
        </Row>
      </div>
      <Row className="mt-auto">
        <Col className="d-flex justify-content-center gap-3">
          <Button className="bo-button" onClick={handleCreate}>
            Create
          </Button>
          <Button className="bo-button" onClick={close}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default ReportsDatesInputModalForm;
